// extracted by mini-css-extract-plugin
module.exports = {"description":"expanded-content-module--description--3qg_J","slideLeft":"expanded-content-module--slideLeft--2EBKZ","floating":"expanded-content-module--floating--EZ3Lg"};